import { normalizeClass } from 'vue';
import { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: Array<ClassValue>) {
	return twMerge(normalizeClass(inputs));
}
